import '../../../../../assets/vendor/swiper/swiper-bundle.js'

export default class DateSlider {
    constructor($slider) {
        this.$slider = $slider;

        this.init = this.init.bind(this);
        this.getActiveDate = this.getActiveDate.bind(this);
    }

    init() {
        this.slider = new Swiper(this.$slider, {
            slidesPerView: 2,
            loop: false,
            slideToClickedSlide: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                576: {
                    slidesPerView: 3,
                },
                768: {

                    slidesPerView: 4,
                },
                992: {
                    slidesPerView: 5,
                }
            }
        });
    }

    getActiveDate() {
        return this.slider.slides[this.slider.activeIndex].dataset.date;
    }
}